import type { PurchaseInvoice } from '@coreledger/shared-types';
import { api } from './client';
import type { PaginationMeta } from './invoices';

export interface Paginated<T> { data: T[]; meta: PaginationMeta }

export const purchasesApi = {
  list: (page = 1, limit = 50) => api.get<Paginated<PurchaseInvoice>>(`/purchase-invoices?page=${page}&limit=${limit}`),
  get: (id: string) => api.get<PurchaseInvoice>(`/purchase-invoices/${id}`),
  create: (data: Partial<PurchaseInvoice>) => api.post<PurchaseInvoice>('/purchase-invoices', data),
  update: (id: string, data: Partial<PurchaseInvoice>) => api.patch<PurchaseInvoice>(`/purchase-invoices/${id}`, data),
  delete: (id: string) => api.delete<void>(`/purchase-invoices/${id}`),
};
